---
title: Ember Supperclub
year: 2024
typology: hospitality
location: Melbourne, FL
summary: A 76-seat restaurant in a former hardware showroom — a single low-lit room with a wood-fired hearth at its center, banquettes in oxblood mohair, and a bar of solid walnut tucked behind a black-steel screen.
heroImage: /projects/ember-supperclub/hero.svg
heroAlt: A low-lit restaurant interior with a central wood-fired hearth, oxblood mohair banquettes, and a walnut bar beyond a steel screen.
materials:
  - Solid walnut
  - Oxblood mohair
  - Blackened steel
  - Hand-troweled lime plaster
  - Antique brass
gallery:
  - src: /projects/ember-supperclub/gallery/01.svg
    alt: Central wood-fired hearth at full burn, the room's gravitational center.
    caption: The hearth at the center — wood fire, no theatrical surround, lit by what it is.
  - src: /projects/ember-supperclub/gallery/02.svg
    alt: Walnut bar with backlit bottles behind a screen of blackened-steel rods.
    caption: The bar wall — solid walnut counter, bottles glowing through a screen of blackened steel rods.
  - src: /projects/ember-supperclub/gallery/03.svg
    alt: Oxblood mohair banquette and a brass pendant lamp.
    caption: Banquettes — oxblood mohair, deep enough for two-hour dinners. Brass pendants tuned warm.
  - src: /projects/ember-supperclub/gallery/04.svg
    alt: Three candlelit tabletops down the length of the room.
    caption: Tables are dressed minimally. The room gets darker as the evening progresses — by plan.
  - src: /projects/ember-supperclub/gallery/05.svg
    alt: The hearth seen from a banquette across the room.
    caption: 'From every seat: the fire. The kitchen''s wood-burning oven IS the room''s focal point.'
placeholder: true
---

A restaurant should feel like an evening, not a renovation.

For Ember, the brief was to take a 1980s hardware showroom — fluorescent ceiling, retail carpet, two structural columns — and find the supper club that had been hiding inside it the whole time. We rebuilt the space around a single moment: the open hearth at the heart of the room.

## The center

Everything radiates from the hearth. Banquettes face it. The bar is offset to one side so the chef's wood-fire becomes the room's natural focal point. Lighting on dimmers; the room gets darker as the evening progresses, by design.

## The bar

A solid walnut counter, fourteen feet long, set behind a screen of blackened steel rods so it reads as architecture, not service. The bottles glow through the gaps. The bartender works from the inside.

## The seating

Oxblood mohair banquettes — saturated, soft, unapologetic. The room is small enough that every seat sees the fire.

*Project complete and operating. Photography forthcoming.*
